import { IFacebookTrackingAdminElement } from '@adminPortal/_common/_interfaces/IFacebookTrackingAdminElement';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TrackingActions = createActionGroup({
  source: 'Tracking',
  events: {
    'Load Facebook Tracking List': emptyProps(),
    'Load Facebook Tracking List Success': props<{ facebookTrackingList: IFacebookTrackingAdminElement[] }>(),
    'Load Facebook Tracking List Failure': props<{ error: any }>(),

    'Create Facebook Tracking': props<{ accessToken: string; pixelId: string }>(),
    'Create Facebook Tracking Success': props<{ facebookTrackingElement: IFacebookTrackingAdminElement }>(),
    'Create Facebook Tracking Failure': props<{ error: any }>(),

    'Delete Facebook Tracking': props<{ id: string }>(),
    'Delete Facebook Tracking Success': props<{ facebookTrackingElement: IFacebookTrackingAdminElement }>(),
    'Delete Facebook Tracking Failure': props<{ error: any }>(),

    'Save Facebook Tracking': props<{ accessToken: string, id: string }>(),
    'Save Facebook Tracking Success': props<{ facebookTrackingElement: IFacebookTrackingAdminElement }>(),
    'Save Facebook Tracking Failure': props<{ error: any }>(),
  },
});
